export default "__VITE_ASSET__B8a6_z3y__"